import React from 'react'
import { Link } from 'react-router-dom'

import { Icon, NavBar } from 'antd-mobile'
import { connect } from 'react-redux'
import './store-header.less'
interface Props {
  title?: string
  goodsTotal?: string | number
}
const QrcodeIcon = () => {
  const click=()=>{
    if (window.WebViewBridge) {
      window.WebViewBridge?.goToScanCode?.call(window.WebViewBridge)
    } else if (window.webkit) {
      window.webkit.messageHandlers.goToScanCode.postMessage(null)
    }
  }
  return (
    <span className="qrcode" onClick={click}>
      <img src="/public/assets/img/mall_qrcode_scan.png" alt="" />
    </span>
  )
}

const SearchIcon = () => (
  <span className="search">
    <Link to="/search">
      <img src="/public/assets/img/search.png" alt="" />
    </Link>
  </span>
)

const GoodCarts = ({ goodsTotal }: any) => (
  <div className="good-carts">
    <Link to="/shoppingcar">
      <img src="/public/assets/img/shopping_cart_icon.png" alt="" />
      {
        parseInt(goodsTotal)>0&&<span className="badge-count font-9">{goodsTotal}</span>
      }

    </Link>
  </div>
)

const mapStateToProps = (state: any) => {
  return {
    title: state.depot.title,
    goodsTotal: state.goods.count,
  }
}

const StoresHeader = ({ title, goodsTotal }: Props) => {
  return (
    <NavBar
      className="store-header"
      mode="light"
      icon={<QrcodeIcon />}
      leftContent={<SearchIcon />}
      rightContent={<GoodCarts goodsTotal={goodsTotal} />}
    >
      <Link
        to={{ pathname: '/select-store' }}
        className="font-6"
        style={{ color: '#333' }}
      >
        {title}
        <Icon type="down" color="#919191" style={{ verticalAlign: 'sub' }} />
      </Link>
    </NavBar>
  )
}
export default connect(mapStateToProps)(StoresHeader)
